import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import COPY from "./CPAPFollowupGuideData";
import "./AnnualMaskPurchaseGuide.css";

const CPAPFollowupGuide = () => {
  const [language, setLanguage] = useState("TH");
  const [activeStep, setActiveStep] = useState(-1);
  const copy = COPY[language];
  const step = activeStep >= 0 ? copy.steps[activeStep] : null;

  return (
    <div className="annual-mask-guide" lang={language === "TH" ? "th" : "en"}>
      <header className="amg-header">
        <div>
          <div className="amg-eyebrow">CPAP FOLLOW-UP / GUIDE</div>
          <h2>{copy.title}</h2>
          <p>{copy.subtitle}</p>
        </div>
        <div className="amg-header-actions">
          <div className="amg-language" role="group" aria-label={copy.language}>
            {["TH", "EN"].map((value) => (
              <button key={value} type="button" className={language === value ? "is-active" : ""} aria-pressed={language === value} onClick={() => setLanguage(value)}>
                {value === "TH" ? "TH · ไทย" : "EN · English"}
              </button>
            ))}
          </div>
          <Button as={Link} to="/cpap-followup-calendar" variant="outline-primary" size="sm">{copy.calendar}</Button>
        </div>
      </header>

      <div className="amg-layout">
        <nav className="amg-navigation" aria-label={copy.navigation}>
          <div className="amg-nav-label">{copy.navigation}</div>
          <button type="button" className={`amg-nav-item ${activeStep === -1 ? "is-active" : ""}`} aria-current={activeStep === -1 ? "step" : undefined} onClick={() => setActiveStep(-1)}>
            <span className="amg-step-number">◎</span>
            <span>{copy.start}<small>{copy.intro}</small></span>
          </button>
          {copy.steps.map((item, index) => (
            <button key={index} type="button" className={`amg-nav-item ${activeStep === index ? "is-active" : ""}`} aria-current={activeStep === index ? "step" : undefined} onClick={() => setActiveStep(index)}>
              <span className="amg-step-number">{index + 1}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="amg-reading-column">
          <article className="amg-article" aria-labelledby="followup-guide-step-title" aria-live="polite">
            <div className="amg-article-heading">
              <div className="amg-step-meta">
                <span>{step ? `${copy.step} ${activeStep + 1} ${copy.of} ${copy.steps.length}` : copy.intro}</span>
              </div>
              <h3 id="followup-guide-step-title">{step ? step.title : copy.start}</h3>
              {!step && <p>{copy.introText}</p>}
            </div>
            <div className="amg-instructions">
              {!step && <div className="amg-preparation-label">{copy.count}</div>}
              <ol className="amg-instruction-list">
                {(step ? step.items : copy.preparation).map((item) => <li key={item}>{item}</li>)}
              </ol>
            </div>
            <footer className="amg-step-footer">
              <Button variant="outline-secondary" size="sm" disabled={activeStep === -1} onClick={() => setActiveStep(activeStep - 1)}>← {copy.previous}</Button>
              <span>{step ? `${activeStep + 1} / ${copy.steps.length}` : copy.intro}</span>
              <Button variant="primary" size="sm" onClick={() => setActiveStep(activeStep === copy.steps.length - 1 ? -1 : activeStep + 1)}>{activeStep === copy.steps.length - 1 ? copy.back : copy.next} →</Button>
            </footer>
          </article>

          <section className="amg-reference" aria-label={copy.reference}>
            {copy.references.map((reference, index) => (
              <details key={index}>
                <summary>{reference.title}</summary>
                <ul>{reference.items.map((item) => <li key={item}>{item}</li>)}</ul>
              </details>
            ))}
          </section>
        </div>
      </div>
    </div>
  );
};

export default CPAPFollowupGuide;
